import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import Process from "@/components/site/Process";
import Portfolio from "@/components/site/Portfolio";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <WhyUs />
      <Process />
      <Portfolio />
      <Testimonials />
      <Contact />
      <Faq />
      <Footer />
    </main>
  );
}
